export default __webpack_public_path__ + "2059da1130f9069cdace25a3e1976ed5.png";